import React from "react";
import MultiTypeahead, { IMultiTypeaheadProps } from "./MultiTypeahead";
import { TagText, TagCloseButton, ITagProps } from "../tag/Tag";
import { IBaseTypeaheadItem } from "./Typeahead";
import { Tooltip } from "../tooltip";
import CustomTagContainer from "../tag/CustomTagContainer";

interface ITagItem {
  value: string;
  label: string;
}

interface IMultiTagSelectorProps<T extends IBaseTypeaheadItem>
  extends Omit<IMultiTypeaheadProps<T>, "renderSelectedItem" | "renderItem" | "items" | "selectedItems"> {
  selectedTags: T[];
  tags: T[];
  tagProps?: Omit<ITagProps, "children">;
}

export default function MultiTagSelector({
  selectedTags,
  tags,
  onChange,
  tagProps = {},
  ...props
}: IMultiTagSelectorProps<ITagItem>) {
  return (
    <MultiTypeahead
      selectedItems={selectedTags}
      onChange={onChange}
      renderSelectedItem={({ item, onRemove }) => (
        <div css={{ maxWidth: "100%" }}>
          <CustomTagContainer selected={true} title={item.label} {...tagProps} maxWidth="95% !important">
            <TagText>{item.label}</TagText> <TagCloseButton onClick={() => onRemove(item)} />
          </CustomTagContainer>
        </div>
      )}
      items={tags}
      renderItem={({ item, active }) => (
        <div css={{ maxWidth: "100%" }}>
          <Tooltip aria-label="tag" label={item.label} bg="blue.600" color="white" p={2} rounded="md" key={item.value}>
            <CustomTagContainer active={active} {...tagProps}>
              <TagText>{item.label}</TagText>
            </CustomTagContainer>
          </Tooltip>
        </div>
      )}
      {...props}
    />
  );
}
